import { render, staticRenderFns } from "./BackendTracking.vue?vue&type=template&id=4b0e8124&"
import script from "./BackendTracking.vue?vue&type=script&lang=ts&"
export * from "./BackendTracking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports